export default __webpack_public_path__ + "static/media/002-harvest.bb6efbdd.png";